/* eslint-disable @nx/enforce-module-boundaries */
import { addTranslationBundle, TranslationProvider } from '@axo/shared/i18n';
import { MarketCountryCode } from '@axo/shared/types';
import { Card } from '@axo/ui-core/components/Card';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Heading } from '@axo/ui-core/components/typography';
import * as Sentry from '@sentry/browser';
import { AxoFormContextProvider } from '../../../../context/AxoForm/AxoForm';
import {
  PreFormComponentProps,
  PreFormViewProps,
} from '../../../FormProps.types';
import { dk, steps } from '../config';
import axoFormContextProviderOptions from '../config/axoFormContextProviderOptions';
import type { DenmarkFormData } from '../FormData.dk.types';
import { Step1 } from '../steps/Step1';
import styles from './pre.module.scss';

addTranslationBundle({ LoanApplication: { dk } });

const PreFormView = ({
  heading,
  options,
  hasCard = true, // TODO with Card, to not break the current implementation on lendme.dk (for WL it should be false)
}: PreFormViewProps) => {
  Sentry.setTag('axo-form', 'v2');
  Sentry.setTag('country', 'dk');
  Sentry.setTag('product', 'loan');

  const Content = (
    <>
      {heading && <Heading size="m">{heading}</Heading>}
      <Step1 isPre={true} options={options} />
    </>
  );

  return hasCard ? (
    <Card variant="input" className={styles.pre}>
      {Content}
    </Card>
  ) : (
    <Stack gap="m">{Content}</Stack>
  );
};

type CustomPreFormComponentProps = PreFormComponentProps & {
  legacyUrl: string;
};

export function Pre({
  baseUrl,
  legacyUrl,
  redirectUrl,
  ...viewProps
}: CustomPreFormComponentProps) {
  return (
    <TranslationProvider language="dk" ns="LoanApplication">
      <AxoFormContextProvider<DenmarkFormData>
        baseUrl={baseUrl}
        redirectUrl={redirectUrl}
        legacyUrl={legacyUrl}
        steps={[steps[0]]}
        isPre={true}
        options={axoFormContextProviderOptions}
        marketCountry={MarketCountryCode.Denmark}
      >
        <PreFormView {...viewProps} />
      </AxoFormContextProvider>
    </TranslationProvider>
  );
}
